import {  CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedCarpetComponent } from './red-carpet.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ImageCropperModule } from 'ngx-image-cropper';
import { EscapeHtmlPipe } from 'src/app/core/Pipe/keep-html.pipe';

@NgModule({
  declarations: [
    RedCarpetComponent,
    EscapeHtmlPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    FlexLayoutModule,
    ImageCropperModule
  ],
  exports:[
    RedCarpetComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class RedCarpetModule { }
